// Realtor Components - Legacy (старая структура)
export {
  RealtorActions,
  type RealtorActionsProps,
} from "./RealtorActions/RealtorActions";

export {
  RealtorActionBar,
  type RealtorActionBarProps,
} from "./RealtorActionBar/RealtorActionBar";

export {
  PropertyStatusBadge,
  type PropertyStatus,
  type PropertyStatusBadgeProps,
} from "./PropertyStatusBadge/PropertyStatusBadge";

export {
  RealtorContextMenu,
  type RealtorContextMenuProps,
} from "./RealtorContextMenu";

export {
  PropertyAssignment,
  type PropertyAssignmentProps,
} from "./PropertyAssignment";

// New Separated Components (новая структура согласно Figma)
export {
  PropertyActionButtons,
  type PropertyActionButtonsProps,
} from "./PropertyActionButtons";

export {
  PropertyStatusDisplay,
  type PropertyStatusDisplayProps,
  type PropertyStatus as PropertyStatusType,
} from "./PropertyStatusDisplay";

export {
  PropertyAgentInfo,
  type PropertyAgentInfoProps,
} from "./PropertyAgentInfo";

export { RealtorWrapper, type RealtorWrapperProps } from "./RealtorWrapper";
